export const NavData = [
  {
    name: "Home",
    path: "/",
  },
  {
    name: "About",
    path: "/about",
  },
  {
    name: "Our Mission",
    path: "/mission",
  },
  {
    name: "Membership",
    path: "/membership",
  },
  // {
  //   name: "Programs",
  //   path: "/programs",
  // },
  {
    name: "Ministries",
    path: "/ministries",
  },
  {
    name: "Founder",
    path: "/founder",
  },
];
